import React from 'react';
import Catalog from '../components/Catalog';

const CatalogPage = () => {
  return (
    <div>
      <Catalog />
    </div>
  );
};

export default CatalogPage;
